import StaffInfoForm from './StaffInfoForm';

export default StaffInfoForm;
